import { useAppSelector } from '@/hooks/useAppSelector';

import { selectTagsList } from '../services/selectors';

export const useTagsList = () => useAppSelector(selectTagsList);
